<template>
  <div class="detail-box">
    <div v-if="detail">
      <div class="top">
        <span class="job-name">
          {{detail.post}}
        </span>
        <div class="desc">
          {{detail.region}} · {{detail.business}} · {{detail.profession}}
        </div>
      </div>
      <div class="detail">
        <span class="title">
          岗位职责
        </span>
        <div class="job-detail" v-html="detail.duty"></div>
      </div>
      <div class="detail">
        <span class="title">任职要求</span>
        <div class="job-detail" v-html="detail.require"></div>
      </div>
      <div class="email-box">
        <span class="more-title">简历投递地址:</span>
        <a class="email" :href="'mailto:' + detail.email" title="邮箱">{{detail.email}}</a>
      </div>
      <div class="more-box" @click="goJobList">
        <span class="more-title-more" >查看更多</span>
        <svg viewBox="0 0 24 24" class="job-arrow-right-icon__fefc38"><path fill="currentColor" fill-rule="evenodd" d="M15.864 12L7.732 3.868a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .707 0l8.84 8.839a1 1 0 0 1 0 1.414l-8.84 8.839a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 0-.707L15.864 12z"></path></svg>
      </div>
    </div>
  </div>
</template>
<script>
  import dataList from "@/utils/data.json";
  export default {
    data () {
      return {
        detail: null
        
      }
    },
    mounted() {
      let arr = dataList.filter(im => {
        return im && im.id == this.$route.params.id
      })
      this.detail = arr[0]
      window.scrollTo(0, 0);
    },
    methods: {
      goJobList () {
        this.$router.push({
            path:`/jobs`,
        })
      }
    },
  }
</script>
<style lang="scss" scoped>
  .detail-box {
    box-sizing: border-box;
    width: 50%;
    margin: 20px auto;
    padding-bottom: 20px;
    .top {
      border-bottom: 1px solid #ededed;
      .job-name {
        font-size: 22px;
        color: #1f2329;
        line-height: 30px;
        margin: 14px;
        font-weight: 700;
      }
      .desc {
        font-size: 14px;
        color: #646a73;
        line-height: 30px;
        margin: 14px;
        box-sizing: border-box;
      }
    }
    .detail {
      .title {
        font-weight: 700;
        font-size: 18px;
        line-height: 28px;
        color: #1f2329;
        align-items: center;
      }
      &:before {
        margin-right:  20px;
        display: inline-block;
        content: "";
        width: 4px;
        height: 18px;
        background-color: #3370FF;
        margin-right: 0.25rem;
      }
      .job-detail {
        font-size: 14px;
        margin-top: 14px;
        margin-bottom: 14px;
        white-space: pre-line;
        word-break: break-word;
        line-height: 50px;
        color: #646a73;
      }
    }
    
    .more-title {
      color: #2b2f36;
      font-size: 14px;
      line-height: 70px;
      font-weight: 500;
    }
    .email {
      color: #3370FF;
      margin-left: 10px;
      font-size: 14px;

    }
    .job-arrow-right-icon__fefc38 {
      width: 20px;
      height:20px;
      // line-height: 1.5rem;
      color: #646a73;
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);

    }
    .email-box {
      line-height: 1.5;
      position: relative;
      line-height: 2rem;
      box-sizing: border-box;
      width: 100%;
    }
    .more-box {
      background-color: #f8f9fa;
      height: 70px;
      position: relative;
      box-sizing: border-box;
      padding-left: 20px;
      cursor: pointer;
      width: 100%;
      .more-title-more {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 30px;
        font-size: 14px;
      }
    }
  }

</style>